import './style.scss'
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.css'

$(function(){
    new Swiper('#product .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
            el: '#product .swiper-pagination',
            type: 'bullets',
            clickable : true
        },
        breakpoints :{
            768: {
                slidesPerView: 1.1
            } 
        }
    })
})